// extracted by mini-css-extract-plugin
export default {"block":"ChangeEmail_block__QJPIG","field":"ChangeEmail_field__63+Ab","label":"ChangeEmail_label__eWIIM","controls":"ChangeEmail_controls__1G+ix","error":"ChangeEmail_error__-ytmI"};